declare namespace $ {

	type $mol_row__sub_exso_table_1 = $mol_type_enforce<
		ReturnType< $exso_table['total'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_view__attr_exso_table_2 = $mol_type_enforce<
		({ 
			'title': ReturnType< $exso_table['column_content_hint'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_exso_table_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_row__sub_exso_table_4 = $mol_type_enforce<
		ReturnType< $exso_table['column_contents'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_labeler__title_exso_table_5 = $mol_type_enforce<
		ReturnType< $exso_table['column_title'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_exso_table_6 = $mol_type_enforce<
		ReturnType< $exso_table['Column_contents'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_row__sub_exso_table_7 = $mol_type_enforce<
		ReturnType< $exso_table['item_columns'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_list__sub_exso_table_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $exso_table extends $mol_section {
		total( ): readonly(any)[]
		Total( ): $mol_row
		column_title( id: any): string
		column_content_hint( id: any): string
		column_content( id: any): string
		Column_content( id: any): $mol_view
		column_contents( id: any): readonly(any)[]
		Column_contents( id: any): $mol_row
		Column( id: any): $mol_labeler
		item_columns( id: any): readonly(any)[]
		Item( id: any): $mol_row
		item_rows( ): readonly(any)[]
		columns( ): readonly(any)[]
		columns_meta( ): Record<string, any>
		item_key( ): string
		items( ): readonly(any)[]
		items_map( ): any
		reverse( ): boolean
		Content( ): $mol_list
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map